/* Urban Reptiles · movimiento discreto (aparición, trazos, contadores, hero). Sin dependencias. */
(function () {
  document.documentElement.classList.add('js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cuenta(el) {
    if (reduce || el.dataset.hecho) return;
    el.dataset.hecho = '1';
    var fin = parseFloat(el.dataset.cuenta);
    if (isNaN(fin)) return;
    var suf = el.dataset.suf || '';
    var ini = fin > 1000 ? fin - 40 : 0;
    var t0 = performance.now();
    (function paso(t) {
      var k = Math.min(1, (t - t0) / 1200);
      var v = Math.round(ini + (fin - ini) * (1 - Math.pow(1 - k, 3)));
      el.textContent = v + suf;
      if (k < 1) requestAnimationFrame(paso);
    })(t0);
  }

  function observar() {
    var nodos = document.querySelectorAll('.ur-rev:not(.ur-in), .ur-dib:not(.ur-in), [data-cuenta]:not([data-hecho])');
    if (!nodos.length) return;
    if (!('IntersectionObserver' in window)) {
      nodos.forEach(function (n) { n.classList.add('ur-in'); if (n.dataset.cuenta) cuenta(n); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('ur-in');
        // Red de seguridad: si el navegador no corre la transición del trazo, se termina de dibujar igual.
        if (e.target.classList.contains('ur-dib')) {
          setTimeout(function () { e.target.querySelectorAll('[pathLength]').forEach(function (p) { p.style.strokeDashoffset = '0'; }); }, 2000);
        }
        if (e.target.dataset.cuenta) cuenta(e.target);
        e.target.querySelectorAll('[data-cuenta]').forEach(cuenta);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15 });
    nodos.forEach(function (n) { io.observe(n); });
  }

  function hero() {
    document.querySelectorAll('.ur-hero__palabra').forEach(function (w, i) {
      w.style.animationDelay = (0.08 * i + 0.1) + 's';
    });
  }

  function tablas() {
    document.querySelectorAll('.rte table').forEach(function (t) {
      if (t.parentElement.classList.contains('ur-tabla')) return;
      var w = document.createElement('div');
      w.className = 'ur-tabla';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  function init() { hero(); tablas(); observar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // El editor de temas re-renderiza secciones: volver a observar.
  document.addEventListener('shopify:section:load', init);
})();
